<p-toast></p-toast>

<div class="user-management-page">
  <div class="user-management-header">
    <h1 class="user-management-title">User Management ({{ filteredUsers.length }})</h1>
    <div class="user-management-actions">
      <button pButton type="button" class="new-user-button" (click)="addNewUser()">
        <i class="ri-add-line"></i>
        <span>New User</span>
      </button>

    </div>
  </div>

  <div class="users-table-wrap">
    <p-table
      #dt
      [value]="filteredUsers"
      [globalFilterFields]="['firstName', 'lastName', 'email', 'roleName', 'userTypeName', 'userId']"
      styleClass="users-table"
      [paginator]="true"
      [rows]="pageSize"
      [rowsPerPageOptions]="rowsPerPageOptions"
      paginatorDropdownAppendTo="body"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first}-{last} of {totalRecords} records"
      [tableStyle]="{ 'min-width': '100%' }"
      responsiveLayout="scroll"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="firstName" class="col-name">
            <span>Name</span>
            <i class="ri-arrow-up-down-line sort-icon"></i>
          </th>
          <th pSortableColumn="email" class="col-email">
            <span>Email</span>
            <i class="ri-arrow-up-down-line sort-icon"></i>
          </th>
          <th pSortableColumn="roleName" class="col-role">
            <span>Role</span>
            <i class="ri-arrow-up-down-line sort-icon"></i>
          </th>
          <th pSortableColumn="userTypeName" class="col-user-type">
            <span>User Type</span>
            <i class="ri-arrow-up-down-line sort-icon"></i>
          </th>
          <th pSortableColumn="isActive" class="col-status">
            <span>Status</span>
            <i class="ri-arrow-up-down-line sort-icon"></i>
          </th>
          <th pSortableColumn="createdAt" class="col-created">
            <span>Created Date</span>
            <i class="ri-arrow-up-down-line sort-icon"></i>
          </th>
          <th class="col-action">
            <span>Action</span>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-user let-rowIndex="rowIndex">
        <tr [class.alt-row]="rowIndex % 2 === 1">
          <td class="col-name">
            <div class="name-cell">
              <span class="name-accent" [style.background-color]="getUserAccentColor(user, rowIndex)"></span>
              <div class="name-content">
                <span class="name-text">{{ user.firstName }} {{ user.lastName }}</span>
                <span class="id-text">ID: {{ user.userId || '-' }}</span>
              </div>
            </div>
          </td>

          <td class="col-email">
            <span class="email-text">{{ user.email }}</span>
          </td>

          <td class="col-role">
            <span class="tag role-tag" [ngClass]="getRoleTagClass(user.roleName)">{{ user.roleName || 'N/A' }}</span>
          </td>

          <td class="col-user-type">
            <span class="tag user-type-tag">{{ user.userTypeName || 'N/A' }}</span>
          </td>

          <td class="col-status">
            <div class="status-cell">
              <p-toggleSwitch [(ngModel)]="user.isActive" (onChange)="handleStatusToggle(user)"></p-toggleSwitch>
            </div>
          </td>

          <td class="col-created">
            <span class="created-text">{{ user.createdAt ? (user.createdAt | date:'MMM dd, yyyy') : '-' }}</span>
          </td>

          <td class="col-action">
            <div class="action-cell">
              <button pButton type="button" class="action-icon-button edit" (click)="editUser(user)" pTooltip="Edit" tooltipPosition="top">
                <i class="ri-pencil-line"></i>
              </button>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7" class="empty-cell">
            <div class="empty-state">
              <i class="ri-group-line"></i>
              <span>No users found</span>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

